import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./ConsentModal.css";

function ConsentModal({ onAgree }) {
  const [checked, setChecked] = useState(false);
  const navigate = useNavigate();

  const handleAgree = () => {
    if (!checked) return;
    localStorage.setItem("reach_user_consent", "true");
    localStorage.setItem("reach_consent_time", new Date().toISOString());
    onAgree();
  };

  return (
    <div className="consent-overlay">
      <div className="consent-box">

        <h2>⚠️ Important Medical Disclaimer</h2>

        <p>
          REACH AI provides educational health information only.
          It is NOT a substitute for professional medical advice.
        </p>

        <p>
          In case of serious symptoms or emergency,
          contact a qualified doctor immediately.
        </p>

        <div className="consent-checkbox">
          <input
            type="checkbox"
            id="agree"
            checked={checked}
            onChange={() => setChecked(!checked)}
          />
          <label htmlFor="agree">
            I understand and agree to the User Policy
          </label>
        </div>

        <button
          className="policy-link"
          onClick={() => navigate("/policy")}
        >
          Click here for full policy
        </button>

        <div className="consent-buttons">
          <button
            className="agree-btn"
            disabled={!checked}
            onClick={handleAgree}
          >
            I Agree
          </button>

          <button
            className="disagree-btn"
            onClick={() => window.location.href = "https://www.google.com"}
          >
            I Disagree
          </button>
        </div>

      </div>
    </div>
  );
}

export default ConsentModal;